import axios from "axios";
import ConstantList from "../appConfig";

const API_PATH = ConstantList.API_EN_POINT + "/concept-time-alert";

export const pagingConceptAlert = obj => axios.post(API_PATH + "/search-by-page", obj)

export const getConceptAlert = id => axios.get(API_PATH + "/get-by-id/" + id)

export const saveOrUpdate = obj => axios.post(API_PATH + "/save-or-update", obj)

export const deleteConceptAlert = id => axios.delete(API_PATH + "/mark-delete/" + id)

